module.exports = __webpack_public_path__ + "static/media/scoop.9f81aad0.png";